export const tableDetail = {
  NAME: {
    TITLE: "Full Name",
    SORT: "fullName",
  },
  DEPARTMENT: {
    TITLE: "Department",
    SORT: "practice.department.departmentName",
  },
  PRACTICE: {
    TITLE: "Practice",
    SORT: "practice.practiceName",
  },
  ROLE_LEVEL: {
    TITLE: "Role Level",
    SORT: "roleLevel.roleLevelName",
  },
  COMPANY_ID: {
    TITLE: "Company",
    SORT: "company.companyName",
  },
  STATUS: {
    TITLE: "Status",
    SORT: "lastDay",
  },
  JOIN_DATE: {
    TITLE: "Join Date",
    SORT: "joinDate",
  },
  LAST_DATE: {
    TITLE: "Last Date",
    SORT: "lastDay",
  },
  NOTES: {
    TITLE: "Notes",
    SORT: "notes",
  },
};

export const ModalType = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
}

export const TabId = {
  ACTIVE_EMPLOYEE: 0,
  INACTIVE_EMPLOYEE: 1,
};

export const ENewEmployeeKey = {
  ID: 'id',
  FULLNAME: 'fullName',
  AUTHROLE_ID: 'authRoleID',
  USERNAME: 'userName',
  DEPARTMENT_ID: 'departmentID',
  PRACTICE_ID: 'practiceID',
  ROLELEVEL_ID: 'roleLevelID',
  ROLE_DESCRIPTION: 'roleDescription',
  JOIN_DATE: 'joinDate',
  COMPANY_ID: 'companyID',
  LAST_DAY: 'lastDay',
  NOTES: 'notes',
  STATUS: 'status',
}

export const generalPracticesNames = ['General', 'New Member', 'People Partner', 'SE Admin'];